import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../select';
import { PossibleSuffixes } from './possible-suffixes';

const Suffix = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseSelect
      label="Suffix"
      name="suffix"
      options={PossibleSuffixes}
      transparent
      disabledStateValue={{ value: 'default', label: 'Select Suffix' }}
      data-cv-test="suffix"
      {...props}
      data-cv-test-override={dataCvTest || 'nameSuffix'}
      canContainEmptyDefaultValue
    />
  );
};

Suffix.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

Suffix.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': 'suffix'
};

export default Suffix;
